// extracted by mini-css-extract-plugin
export default {"edgeDeviceConfigPreviewTitle":"GlobalConfig_edgeDeviceConfigPreviewTitle__4Nuxj","subTitle":"GlobalConfig_subTitle__cNLdw"};